/* eslint-disable
    guard-for-in,
    no-restricted-syntax
*/
// TODO: This file was updated by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import $ from 'jquery';
import reactUpdate from 'immutability-helper';
import _ from 'underscore';

import {assert} from 'Asserts';
import * as CRISPRConstants from 'constants/CRISPRConstants';
import {EventConstants} from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';
import notifications from 'notifications';

import CRISPRAnalysisDAO from './CRISPRAnalysisDAO';
import CRISPRRegionDAO from './CRISPRRegionDAO';
import * as CRISPRUtil from './CRISPRUtil';

const CRISPRAnalysisActions = {};

CRISPRAnalysisActions.__findGuides = function ({start, end}, {analysis, search, sequence}) {
  assert(start != null && end != null);
  let guides = CRISPRUtil.findGuides(sequence, search, analysis, start, end);
  guides = CRISPRUtil.filterGuides(sequence, analysis, guides);
  return guides;
};

// Given a region update payload (`data`, with start/end) and guide-search context
// (`findGuidesParams`: analysis, search, sequence), recompute filtered guides for those bounds
// and return a new payload with `guides` merged in. Does not mutate inputs.
CRISPRAnalysisActions.__withGuides = (data, findGuidesParams) =>
  reactUpdate(data, {$merge: {guides: CRISPRAnalysisActions.__findGuides(data, findGuidesParams)}});

// Split a bulk-update response into the regions that were updated (keyed by id) and the errors to
// surface for regions that failed.
CRISPRAnalysisActions.__partitionBulkUpdateRegionResponse = function (response, regions) {
  const regionsMap = response.regions ?? {};
  const errorsMap = response.errors ?? {};
  const updatedRegions = {};
  const failedErrors = [];
  for (const region of regions) {
    const updatedRegion = regionsMap[region.id];
    if (updatedRegion != null) {
      updatedRegions[region.id] = updatedRegion;
    } else {
      failedErrors.push(errorsMap[region.id]);
    }
  }
  return {updatedRegions, failedErrors};
};

CRISPRAnalysisActions.analyzeOnTargetBulk = function (analysisId, regionIds) {
  if (regionIds.length === 0) {
    return;
  }
  CRISPRRegionDAO.analyzeOnTarget(regionIds)
    .done((response) => {
      for (const regionId in response) {
        const region = response[regionId];
        AppDispatcher.dispatch({
          actionType: EventConstants.CRISPR_REGION_ANALYZE_ON_TARGET_COMPLETED,
          analysisId,
          regionId,
          region,
        });
      }
    })
    .fail((response) => {
      const errors = __guard__(response.responseJSON, (x) => x.errors);
      if (__guard__(errors, (x1) => x1.circularSequenceError) == null) {
        notifications.notifyError(response);
      }
    });
};

// Recompute each region's guides, persist them in one bulk request, and merge the response into the
// store as a single batch. Use when all regions of an analysis must be updated together (recompute
// guides, regenerate, or analysis settings that invalidate every region). Use __updateRegion to change
// a single region. Pass shouldClearGenomeRegion to drop genome-region fields from every payload.
CRISPRAnalysisActions.__updateAllRegions = function (analysisId, findGuidesParams, shouldClearGenomeRegion) {
  const {regions} = findGuidesParams.analysis;

  if (regions.length === 0) {
    return [];
  }

  const payloads = regions.map((region) => {
    let data = {start: region.start, end: region.end};
    if (shouldClearGenomeRegion) {
      data = _.extend({}, data, {
        genomeRegionChromosome: null,
        genomeRegionEnd: null,
        genomeRegionStart: null,
      });
    }
    return reactUpdate(CRISPRAnalysisActions.__withGuides(data, findGuidesParams), {
      $merge: {regionId: region.id},
    });
  });

  // Track this batch by id so a single settle balances the whole batch's loading state (one re-render
  // instead of one per region), and removal stays correct even if a settle repeats.
  const batchId = _.uniqueId('crispr_bulk_');
  AppDispatcher.dispatch({actionType: EventConstants.CRISPR_REGIONS_BULK_UPDATE, batchId});

  // Merge the updated regions into the store in a single mutation + re-render and balance the batch's
  // loading state. Dispatched from a `finally` so loading is always balanced, even if response
  // processing throws.
  const settle = (updatedRegions) =>
    AppDispatcher.dispatch({
      actionType: EventConstants.CRISPR_REGIONS_BULK_UPDATE_SETTLED,
      analysisId,
      updatedRegions,
      batchId,
    });

  const xhr = CRISPRRegionDAO.bulkUpdate(payloads)
    .done((response) => {
      let updatedRegions = {};
      try {
        const partition = CRISPRAnalysisActions.__partitionBulkUpdateRegionResponse(response, regions);
        updatedRegions = partition.updatedRegions;
        // One danger toast per region that failed validation, mirroring the per-region path. These
        // are per-region business errors from a 200 response (plain strings), so use
        // notifications.error (which renders a raw string) rather than notifyError (which expects a
        // jqXHR/Response and would otherwise fall back to a generic message).
        partition.failedErrors.forEach((error) => notifications.error(error ?? 'Region update failed.'));
      } finally {
        settle(updatedRegions);
      }
      for (const regionId of Object.keys(updatedRegions)) {
        CRISPRAnalysisActions.analyzeRegionOffTarget(analysisId, regionId);
      }
    })
    .fail((response) => {
      // Transport/status failure: no region was updated. Surface one error and still balance loading.
      try {
        notifications.notifyError(response);
      } finally {
        settle({});
      }
    });

  // Reject the returned promise if any region failed, so callers gating on $.when(...) (on-target
  // bulk scoring, regenerate completion) short-circuit exactly as they did when each region was a
  // separate XHR that could reject.
  const gatedPromise = xhr.then((response) =>
    Object.keys(response.errors ?? {}).length > 0 ? $.Deferred().reject(response).promise() : response
  );
  return [gatedPromise];
};

CRISPRAnalysisActions.__scoreOnTargetOnUpdate = function (regionXHRs, analysis) {
  const regionIds = _.pluck(analysis.regions, 'id');
  // Wait for regions to update with new guide information before computing azimuth score
  $.when(...regionXHRs).done(() => CRISPRAnalysisActions.analyzeOnTargetBulk(analysis.id, regionIds));
};

CRISPRAnalysisActions.recomputeGuides = function (analysisId, findGuidesParams) {
  const shouldClearGenomeRegion = false;
  const regionXHRs = CRISPRAnalysisActions.__updateAllRegions(
    analysisId,
    findGuidesParams,
    shouldClearGenomeRegion
  );
  CRISPRAnalysisActions.__scoreOnTargetOnUpdate(regionXHRs, findGuidesParams.analysis);
};

CRISPRAnalysisActions.__update = function (analysisId, data, findGuidesParams) {
  AppDispatcher.dispatch({actionType: EventConstants.CRISPR_ANALYSIS_UPDATE});

  // Updating these fields shouldn't cause a recompute of guides.
  const ignoredRegionKeys = ['name', 'pamSiteOnTargetMin', 'pamSiteOffTargetMin', 'originalBases'];
  return CRISPRAnalysisDAO.update(analysisId, data)
    .done((analysis) => {
      const regionKeys = _.chain(data)
        .keys()
        .reject((key) => Array.from(ignoredRegionKeys).includes(key))
        .value();
      const shouldUpdateRegion = regionKeys.length > 0;
      if (shouldUpdateRegion) {
        // Clear guides on each region because we're going to recompute and dispatching
        // CRISPR_ANALYSIS_UPDATE_COMPLETED with old guides and new settings will cause errors.
        analysis = reactUpdate(analysis, {
          regions: {
            $set: analysis.regions.map((region) =>
              reactUpdate(region, {
                guides: {$set: []},
              })
            ),
          },
        });
      }
      // eslint-disable-next-line benchlint/no-in-operator
      if ('designType' in data) {
        CRISPRAnalysisActions.updateGuideGroupSort(analysis.id, {
          key: CRISPRConstants.SORT_KEY.POSITION,
          reverse: false,
        });
      }
      AppDispatcher.dispatch({
        actionType: EventConstants.CRISPR_ANALYSIS_UPDATE_COMPLETED,
        analysisId,
        analysis,
      });
      const shouldClearGenomeRegion = Array.from(regionKeys).includes('genome');
      assert(shouldUpdateRegion || !shouldClearGenomeRegion);
      if (shouldUpdateRegion) {
        findGuidesParams = reactUpdate(findGuidesParams, {analysis: {$set: analysis}});
        const regionXHRs = CRISPRAnalysisActions.__updateAllRegions(
          analysisId,
          findGuidesParams,
          shouldClearGenomeRegion
        );
        CRISPRAnalysisActions.__scoreOnTargetOnUpdate(regionXHRs, analysis);
      } else {
        // We don't store on-target scores in the DB, so we need to recalculate them
        CRISPRAnalysisActions.analyzeOnTargetBulk(analysis.id, _.pluck(analysis.regions, 'id'));
      }
    })
    .fail((response) => {
      notifications.notifyError(response);
      AppDispatcher.dispatch({actionType: EventConstants.CRISPR_ANALYSIS_UPDATE_FAILED});
    });
};

CRISPRAnalysisActions.__deleteRegion = function (analysisId, regionId) {
  AppDispatcher.dispatch({actionType: EventConstants.CRISPR_REGION_DELETE});
  return CRISPRRegionDAO.delete(regionId)
    .done((response) => {
      AppDispatcher.dispatch({
        actionType: EventConstants.CRISPR_REGION_DELETE_COMPLETED,
        analysisId,
        regionId,
      });
    })
    .fail((response) => {
      notifications.notifyError(response);
      AppDispatcher.dispatch({actionType: EventConstants.CRISPR_REGION_DELETE_FAILED});
    });
};

CRISPRAnalysisActions.__updateRegion = function (
  analysisId,
  regionId,
  data,
  findGuidesParams,
  reanalyzeOnTarget
) {
  AppDispatcher.dispatch({actionType: EventConstants.CRISPR_REGION_UPDATE});
  data = CRISPRAnalysisActions.__withGuides(data, findGuidesParams);
  return CRISPRRegionDAO.update(regionId, data)
    .done((response) => {
      AppDispatcher.dispatch({
        actionType: EventConstants.CRISPR_REGION_UPDATE_COMPLETED,
        analysisId,
        regionId,
        region: response,
      });
      CRISPRAnalysisActions.analyzeRegionOffTarget(analysisId, regionId);
      if (reanalyzeOnTarget) {
        CRISPRAnalysisActions.analyzeOnTargetBulk(analysisId, [regionId]);
      }
    })
    .fail((response) => {
      notifications.notifyError(response);
      AppDispatcher.dispatch({actionType: EventConstants.CRISPR_REGION_UPDATE_FAILED});
    });
};

CRISPRAnalysisActions.__unpackRegions = (packedRegions, findGuidesParams) =>
  packedRegions.map((region) => {
    const {start, end} = region;
    const guides = CRISPRAnalysisActions.__findGuides({start, end}, findGuidesParams);
    return {start, end, guides};
  });

function createAnalysis(analysisCid, data) {
  AppDispatcher.dispatch({actionType: EventConstants.CRISPR_ANALYSIS_CREATE});
  CRISPRAnalysisDAO.create(data)
    .done((response) => {
      AppDispatcher.dispatch({
        actionType: EventConstants.CRISPR_ANALYSIS_CREATE_COMPLETED,
        analysis: response,
        analysisId: response.id,
        analysisCid,
      });
    })
    .fail((response) => {
      notifications.notifyError(response);
      AppDispatcher.dispatch({actionType: EventConstants.CRISPR_ANALYSIS_CREATE_FAILED});
    });
}

CRISPRAnalysisActions.createWithRegions = function (analysisCid, data, findGuidesParams, regions) {
  const regionsDicts = CRISPRAnalysisActions.__unpackRegions(regions, findGuidesParams);
  createAnalysis(analysisCid, _.extend({}, data, {regions: regionsDicts}));
};

CRISPRAnalysisActions.create = (analysisCid, data) => createAnalysis(analysisCid, data);

CRISPRAnalysisActions.delete = function (analysisId) {
  AppDispatcher.dispatch({
    actionType: EventConstants.CRISPR_ANALYSIS_DELETE,
    analysisId,
  });
  CRISPRAnalysisDAO.delete(analysisId)
    .done((response) => {
      AppDispatcher.dispatch({
        actionType: EventConstants.CRISPR_ANALYSIS_DELETE_COMPLETED,
        analysisId,
      });
    })
    .fail((response) => {
      notifications.notifyError(response);
      AppDispatcher.dispatch({actionType: EventConstants.CRISPR_ANALYSIS_DELETE_FAILED});
    });
};

CRISPRAnalysisActions.open = function (analysisId) {
  AppDispatcher.dispatch({actionType: EventConstants.CRISPR_ANALYSIS_OPEN});
  CRISPRAnalysisDAO.open(analysisId)
    .done((response) => {
      AppDispatcher.dispatch({
        actionType: EventConstants.CRISPR_ANALYSIS_OPEN_COMPLETED,
        analysisId,
        analysis: response,
      });
    })
    .fail((response) => {
      notifications.notifyError(response);
      AppDispatcher.dispatch({actionType: EventConstants.CRISPR_ANALYSIS_OPEN_FAILED});
    });
};

CRISPRAnalysisActions.update = function (analysisId, data, findGuidesParams) {
  CRISPRAnalysisActions.__update(analysisId, data, findGuidesParams);
};

CRISPRAnalysisActions.createRegion = function (analysisId, data, findGuidesParams) {
  AppDispatcher.dispatch({actionType: EventConstants.CRISPR_REGION_CREATE});
  const guides = CRISPRAnalysisActions.__findGuides(data, findGuidesParams);
  data = reactUpdate(data, {$merge: {analysis: analysisId, guides}});
  CRISPRRegionDAO.create(data)
    .done((response) => {
      AppDispatcher.dispatch({
        actionType: EventConstants.CRISPR_REGION_CREATE_COMPLETED,
        analysisId,
        regionId: response.id,
        region: response,
      });
      CRISPRAnalysisActions.analyzeRegionOffTarget(analysisId, response.id);
      CRISPRAnalysisActions.analyzeOnTargetBulk(analysisId, [response.id]);
    })
    .fail((response) => {
      notifications.notifyError(response);
      AppDispatcher.dispatch({actionType: EventConstants.CRISPR_REGION_CREATE_FAILED});
    });
};

CRISPRAnalysisActions.analyzeRegionOffTarget = function (analysisId, regionId) {
  CRISPRRegionDAO.analyzeOffTarget(regionId)
    .done((response) => {
      AppDispatcher.dispatch({
        actionType: EventConstants.CRISPR_REGION_ANALYZE_OFF_TARGET_COMPLETED,
        analysisId,
        regionId,
        region: response,
      });
    })
    .fail((response) => {
      // Don't notify the user for 404, because
      //  - this off-target scoring request is sent automatically
      //  - it means that the CRISPR region was deleted by the time it was processed for off-target scoring
      if (response.status !== 404) {
        notifications.notifyError(response);
      }
    });
};

CRISPRAnalysisActions.updateRegion = function (analysisId, regionId, data, findGuidesParams) {
  CRISPRAnalysisActions.__updateRegion(analysisId, regionId, data, findGuidesParams, true);
};

CRISPRAnalysisActions.deleteRegion = function (analysisId, regionId) {
  CRISPRAnalysisActions.__deleteRegion(analysisId, regionId);
};

CRISPRAnalysisActions.toggleSelectedRegions = function (analysisId, regionIds, selected) {
  AppDispatcher.dispatch({
    actionType: EventConstants.CRISPR_ANALYSIS_TOGGLE_SELECTED_REGIONS,
    analysisId,
    regionIds,
    selected,
  });
};

CRISPRAnalysisActions.fetchForSequence = function (sequenceId) {
  AppDispatcher.dispatch({actionType: EventConstants.CRISPR_ANALYSIS_FETCH_FOR_SEQUENCE});
  CRISPRAnalysisDAO.fetchForSequence(sequenceId)
    .done(({data}) => {
      AppDispatcher.dispatch({
        actionType: EventConstants.CRISPR_ANALYSIS_FETCH_FOR_SEQUENCE_COMPLETED,
        analyses: data,
      });
    })
    .fail((response) => {
      notifications.notifyError(response);
      AppDispatcher.dispatch({actionType: EventConstants.CRISPR_ANALYSIS_FETCH_FOR_SEQUENCE_FAILED});
    });
};

CRISPRAnalysisActions.updateGuideGroupSort = function (analysisId, sort) {
  AppDispatcher.dispatch({
    actionType: EventConstants.CRISPR_ANALYSIS_UPDATE_GUIDE_GROUP_SORT,
    analysisId,
    sort,
  });
};

CRISPRAnalysisActions.toggleSelectedGuideGroups = function (analysisId, guideGroups, selected) {
  AppDispatcher.dispatch({
    actionType: EventConstants.CRISPR_ANALYSIS_TOGGLE_SELECTED_GUIDE_GROUPS,
    analysisId,
    guideGroups,
    selected,
  });
};

CRISPRAnalysisActions.fetchOriginalSequenceVersion = function (analysisId) {
  CRISPRAnalysisDAO.fetchOriginalSequenceVersion(analysisId).done(({originalSequenceVersion}) => {
    AppDispatcher.dispatch({
      actionType: EventConstants.CRISPR_ANALYSIS_ORIGINAL_SEQUENCE_VERSION_FETCH_COMPLETED,
      analysisId,
      originalSequenceVersion,
    });
  });
};

CRISPRAnalysisActions.regenerateAnalysis = function (analysis, sequence, findGuidesParams) {
  AppDispatcher.dispatch({
    actionType: EventConstants.CRISPR_ANALYSIS_REGENERATE,
  });

  const regionFindGuidesParams = reactUpdate(findGuidesParams, {analysis: {$set: analysis}});
  const regionXHRs = [];
  const regenerableRegions = [];
  for (const region of Array.from(analysis.regions)) {
    if (CRISPRUtil.canRegenerateRegion(region, sequence.length)) {
      regenerableRegions.push(region);
    } else {
      regionXHRs.push(CRISPRAnalysisActions.__deleteRegion(analysis.id, region.id));
    }
  }

  // Update all regenerable regions in a single bulk request. We pass an analysis whose regions are
  // limited to the regenerable set so __updateAllRegions only updates those. shouldClearGenomeRegion
  // is false; on-target scoring is handled in bulk by the call to __update below.
  if (regenerableRegions.length > 0) {
    const bulkFindGuidesParams = reactUpdate(regionFindGuidesParams, {
      analysis: {regions: {$set: regenerableRegions}},
    });
    regionXHRs.push(...CRISPRAnalysisActions.__updateAllRegions(analysis.id, bulkFindGuidesParams, false));
  }

  $.when(...regionXHRs)
    .then(() =>
      CRISPRAnalysisActions.__update(analysis.id, {originalBases: sequence.bases}, findGuidesParams)
    )
    .done(() => {
      AppDispatcher.dispatch({
        actionType: EventConstants.CRISPR_ANALYSIS_REGENERATE_COMPLETED,
      });
    })
    .fail(() => {
      AppDispatcher.dispatch({
        actionType: EventConstants.CRISPR_ANALYSIS_REGENERATE_FAILED,
      });
    });
};

export default CRISPRAnalysisActions;

function __guard__(value, transform) {
  return value != null ? transform(value) : undefined;
}
